import { render, staticRenderFns } from "./UserAuthorization.vue?vue&type=template&id=5006dfe8&scoped=true&lang=pug"
import script from "./UserAuthorization.vue?vue&type=script&lang=js"
export * from "./UserAuthorization.vue?vue&type=script&lang=js"
import style0 from "./UserAuthorization.vue?vue&type=style&index=0&id=5006dfe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5006dfe8",
  null
  
)

export default component.exports